import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';

const Navbar = () => {
  const { cart } = useCart();
  const [cartCount, setCartCount] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Изчисляване на общия брой продукти в кошницата
    const count = cart.items.reduce((total, item) => total + item.quantity, 0);
    setCartCount(count);
  }, [cart.items]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className="bg-primary h-[70px] flex items-center sticky top-0 z-[1000] shadow-md">
      <div className="flex justify-between items-center w-full max-w-7xl mx-auto px-5">
        <Link to="/" className="text-white no-underline text-2xl font-bold flex items-center">
          <span className="ml-1">ShopName</span>
        </Link>

        <div className="hidden md:flex items-center list-none m-0 p-0">
          <li className="mx-4">
            <Link to="/" className="text-white no-underline text-base py-2 relative hover:text-gray-100 transition-colors">
              Начало
            </Link>
          </li>
          <li className="mx-4">
            <Link to="/products" className="text-white no-underline text-base py-2 relative hover:text-gray-100 transition-colors">
              Продукти
            </Link>
          </li>
          <li className="mx-4">
            <Link to="/cart" className="text-white no-underline text-base py-2 relative hover:text-gray-100 transition-colors flex items-center">
              <span>Кошница</span>
              {cartCount > 0 && (
                <span className="bg-secondary text-white text-xs w-5 h-5 rounded-full flex items-center justify-center ml-1">
                  {cartCount}
                </span>
              )}
            </Link>
          </li>
        </div>

        <div className="block md:hidden cursor-pointer" onClick={toggleMobileMenu}>
          <span className={`block relative w-[30px] h-[3px] ${mobileMenuOpen ? 'bg-transparent' : 'bg-white'} transition-all duration-300`}>
            <span className={`absolute w-[30px] h-[3px] bg-white transition-all duration-300 ${mobileMenuOpen ? 'rotate-45 translate-y-0' : '-translate-y-[10px]'}`}></span>
            <span className={`absolute w-[30px] h-[3px] bg-white transition-all duration-300 ${mobileMenuOpen ? '-rotate-45 translate-y-0' : 'translate-y-[10px]'}`}></span>
          </span>
        </div>

        <div className={`md:hidden flex flex-col w-full absolute top-[70px] ${mobileMenuOpen ? 'left-0 opacity-100' : '-left-full opacity-0'} transition-all duration-500 ease-in-out bg-primary py-5 z-[1]`}>
          <div className="py-2.5 w-full text-center" onClick={() => setMobileMenuOpen(false)}>
            <Link to="/" className="text-white no-underline text-base block w-full p-2.5">
              Начало
            </Link>
          </div>
          <div className="py-2.5 w-full text-center" onClick={() => setMobileMenuOpen(false)}>
            <Link to="/products" className="text-white no-underline text-base block w-full p-2.5">
              Продукти
            </Link>
          </div>
          <div className="py-2.5 w-full text-center" onClick={() => setMobileMenuOpen(false)}>
            <Link to="/cart" className="text-white no-underline text-base flex items-center justify-center w-full p-2.5">
              <span>Кошница</span>
              {cartCount > 0 && (
                <span className="bg-secondary text-white text-xs w-5 h-5 rounded-full flex items-center justify-center ml-1">
                  {cartCount}
                </span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 